export default __webpack_public_path__ + "static/media/Perevozshikov.469d9c95.jpg";